import React from 'react';

const ExpenseAdd: React.FC = () => {
  return (
    <div>
      {/* Expense addition form will go here */}
    </div>
  );
};

export default ExpenseAdd; 